import React, { Component } from 'react'

class IsNotPresent extends Component {

  componentDidMount() {
    const { onChange } = this.props

    // no real value associated with this type of operator - but we need
    // to specify true anyway.
    onChange(true)
  }

  render() {
    return <div />
  }
}

export default IsNotPresent